const $ = require("jquery");
const SecondaryDemoFormStepper = require('./SecondaryDemoFormStepper');
const ZoomInfo = require("../../utilities/ZoomInfo");

class SecondaryDemoForm {
	constructor (id, utmCookies, loggerFactory) {
		this.id = id;
		new SecondaryDemoFormStepper(
			$(`#${id} [data-component="secondary-demo-form-stepper"]`)[0].id
		);

		utmCookies.initForm($(`#${id} form`)[0]);

		new ZoomInfo(
			"313a46fb-07ed-46af-ba8f-5bf78cb29d82",
			"secondary-demo-form",
			`#${this.id} form`,
			`#${this.id} form [name="Email"]`,
			[
				`#${this.id} form [name="FirstName"]`,
				`#${this.id} form [name="LastName"]`,
				`#${this.id} form [name="Company"]`,
				`#${this.id} form [name="Company_Size_Range__c"]`
			],
			loggerFactory,
			'secondary-demo-form-input-wrapper'
		);
	}
}

SecondaryDemoForm.init = (utmCookies, loggerFactory) => {
	const objects = [];

	$('[data-component=secondary-demo-form]').each((_, e) => {
		const id = $(e).attr("id");
		objects.push(new SecondaryDemoForm(id, utmCookies, loggerFactory));
	});

	return objects;
}

module.exports = SecondaryDemoForm;
